import type { Propuesta } from '../services/propuestas';
import type { Restaurante } from '../../database/database';

type PropuestaConBypassLegacy = Pick<Propuesta, 'restaurante'> & {
  bypass_rango_restaurante?: boolean;
};

function bypassRangoDesdeFilaPropuesta(
  propuesta: PropuestaConBypassLegacy | null | undefined,
): boolean {
  if (!propuesta) return false;
  return (
    propuesta.restaurante?.bypass_rango_restaurante === true ||
    propuesta.bypass_rango_restaurante === true
  );
}

/** Bypass de distancia al local (restaurante + respaldo legacy en fila propuestas). */
export function restauranteBypassRangoVotacionActivo(
  propuesta: PropuestaConBypassLegacy | null | undefined,
  restauranteFallback?: Pick<Restaurante, 'bypass_rango_restaurante'> | null,
): boolean {
  return (
    bypassRangoDesdeFilaPropuesta(propuesta) ||
    restauranteFallback?.bypass_rango_restaurante === true
  );
}

/** Une bypass del join restaurante con el flag legacy aún en la tabla propuestas. */
export function mergeBypassRangoRestauranteEnJoin<T extends Record<string, unknown>>(
  propuestaRow: T,
): T {
  const rest = propuestaRow.restaurante;
  const legacyBypass = propuestaRow.bypass_rango_restaurante === true;
  if (!rest || typeof rest !== 'object' || Array.isArray(rest)) {
    return propuestaRow;
  }
  const restRec = rest as Record<string, unknown>;
  const bypassActivo = restRec.bypass_rango_restaurante === true || legacyBypass;
  if (restRec.bypass_rango_restaurante === bypassActivo) {
    return propuestaRow;
  }
  return {
    ...propuestaRow,
    restaurante: {
      ...restRec,
      bypass_rango_restaurante: bypassActivo,
    },
  };
}
